import {createContext, useContext} from "react";
import User from "@/auth/User.ts";

export const AuthContext = createContext<User | null>(null);

export function useAuthenticatedUser(): User {
    const user = useContext(AuthContext);
    if (!user) throw new Error("useAuthenticatedUser must be used inside AuthProvider");
    return user;
}
